import { z } from 'zod';

export const categoryMappingSlugSchema = z.enum(['category-import-mapping', 'category-neuro-mapping']);

export type CategoryMappingSlugSchema = z.infer<typeof categoryMappingSlugSchema>;
